import { getRootWindow } from '../utils/window';

export function publish<Payload = any>(type: string, payload?: Payload): void {
  getRootWindow().dispatchEvent(
    new CustomEvent<Payload>(type, { detail: payload }),
  );
}

// Loading events
export const MFE_START_LOADING_EVENT = 'sxm_mfe_start_loading';
export const MFE_STOP_LOADING_EVENT = 'sxm_mfe_stop_loading';
export const MFE_RESET_LOADING_EVENT = 'sxm_mfe_reset_loading';
export const publishStartLoading = () => publish(MFE_START_LOADING_EVENT);
export const publishStopLoading = () => publish(MFE_STOP_LOADING_EVENT);
export const publishResetLoading = () => publish(MFE_RESET_LOADING_EVENT);

// Datadog events
export const MFE_PUBLISH_ERROR_TO_DATADOG = 'sxm_mfe_publish_error_to_datadog';
export const publishErrorToDatadog = (error: any) => {
  publish<any>(MFE_PUBLISH_ERROR_TO_DATADOG, error);
};

// Auth events
export const MFE_LOGIN_SUCCESS = 'sxm_mfe_login_success';
export const MFE_LOGAS_SUCCESS = 'sxm_mfe_logas_success';
export const MFE_LOGOUT_EVENT = 'sxm_mfe_logout';
